/* global debounce, trapFocus */

if (!customElements.get('cart-items')) {
  class CartItems extends HTMLElement {
    constructor() {
      super();
      if (this.dataset.empty === 'false') this.init();
    }

    init() {
      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };

      this.cartDrawer = document.getElementById('cart-drawer');
      this.itemStatus = document.getElementById('cart-line-item-status');
      this.currentTotalItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
        (total, quantityInput) => total + parseInt(quantityInput.value, 10),
        0
      );

      this.currentQuantities = [];
      this.querySelectorAll('.cart-item').forEach((item) => {
        this.currentQuantities[item.dataset.variantId] = Number(item.querySelector('.qty-input__input').value);
      });

      this.addEventListener('click', this.handleClick.bind(this));

      // ETA resolution layer: restamp lines whose promised arrival has passed.
      this.restampStaleEta();

      // Two-tier change handling:
      //  - Button (minus/plus) presses dispatch a CustomEvent with detail.fromButton=true.
      //    Fire the AJAX update IMMEDIATELY so mobile users get instant feedback.
      //  - Direct input typing keeps the 300ms debounce so we don't spam Shopify
      //    while the user is typing a multi-digit quantity.
      this._debouncedHandleChange = debounce(this.handleChange.bind(this));
      this.addEventListener('change', (evt) => {
        const fromButton = evt.detail && evt.detail.fromButton === true;
        if (fromButton) {
          this.handleChange(evt);
        } else {
          this._debouncedHandleChange(evt);
        }
      });
    }

    /**
     * Handles 'click' events on the cart items element.
     * @param {object} evt - Event object.
     */
    handleClick(evt) {
      const removeBtn = evt.target.closest('.js-remove-item');
      if (!removeBtn) return;
      evt.preventDefault();

      // NOTE: We intentionally do NOT call enableLoading() synchronously here.
      // enableLoading() internally calls document.activeElement.blur(), which
      // on iOS Safari interferes with the in-flight click event when run
      // synchronously inside a click handler on the just-clicked button:
      // the AJAX initiates but the UI update appears to require a second tap.
      // updateQuantity() (called below) is async and will invoke enableLoading
      // on the next microtask, which works fine.
      if (removeBtn.hasAttribute('data-priority') && removeBtn.dataset.priority === 'main') {
        this.removeHighPriorityItemsSequentially();
      } else {
        this.updateQuantity(removeBtn.dataset.index, 0);
      }
    }

     async checkAndRemoveSpecificProduct() {
 
  const specificVariantId = 46692864065836;

  try {
    const response = await fetch('/cart.js?timestamp=' + Date.now(), { cache: 'no-store' });
    const cart = await response.json();

    if (!cart.items || cart.items.length === 0) {
      if (this.cartDrawer) this.cartDrawer.refresh(true);
      return;
    }

    const specificProduct = cart.items.find(i => i.id === specificVariantId);

    if (specificProduct && cart.items.length === 1) {
      console.log("Auto-removing specific product.");

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: { [specificProduct.key]: 0 }
        })
      });

      if (this.cartDrawer) {
        this.cartDrawer.refresh(true);
      } else {
        window.location.reload();
      }
    }
  } catch (err) {
    console.error("Error in specific removal:", err);
  }
}



    async  removeHighPriorityItemsSequentially() {
  const highPriorityItems = document.querySelectorAll('cart-items [data-priority]');
  if (highPriorityItems.length === 0) return;

  let sections = 'cart-icon-bubble';
  const cart = document.querySelector('cart-drawer');

  if (cart) {
    const sectionId = cart.closest('.shopify-section')?.id?.replace('shopify-section-', '');
    if (sectionId) sections += `,${sectionId}`;
  }

  for (let index = 0; index < highPriorityItems.length; index++) {
    const item = highPriorityItems[index];
    const line = parseInt(item.dataset.index - 1); // ✅ Must be number
    const quantity = 0;

    const formData = {
      line,
      quantity,
      sections,
      sections_url: window.location.pathname
    };

    console.log("🔁 Sending cart change for line:", line);

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      const state = await response.json();
 console.log(state)
      console.log(formData)
      if (index === highPriorityItems.length - 1) {
        // ✅ Only run after last item is removed
        if (cart && typeof cart.renderContents === 'function' && state.sections) {
          cart.renderContents(state, true);
        } else {
          // window.location = theme.routes.cart_url;
        }
      }
    } catch (error) {
      console.error(`❌ Failed to remove line ${line}:`, error);
    }
  }
}



    /**
     * ETA resolution layer — stale-stamp repair.
     *
     * A line keeps the ETA stamped at add-to-cart (properties[Arrives],
     * _eta_days, _eta_extra, _eta_source, _eta_stamped_on) so an order placed
     * inside a closure window keeps that window's promise. The one exception:
     * if the stamped arrival date is already in the past, the promise is
     * meaningless, so the line is restamped with today's resolution. Liquid
     * renders that fresh resolution onto the row (data-eta-fresh-*); this
     * method never computes an ETA itself.
     *
     * Runs once per shop-day per browser session.
     */
    async restampStaleEta() {
      const todayIso = (window.RS_ETA && window.RS_ETA.today) || CartItems.localIsoDate();
      const guardKey = 'rs_eta_restamped';
      let alreadyRan = false;
      try { alreadyRan = sessionStorage.getItem(guardKey) === todayIso; } catch (e) { /* private mode */ }
      if (alreadyRan) return;

      const staleRows = Array.from(this.querySelectorAll('.cart-item[data-eta-stamped-iso]')).filter((row) => {
        const stampedIso = row.dataset.etaStampedIso;
        // ISO dates compare lexicographically.
        return stampedIso && row.dataset.etaFreshLabel && row.dataset.lineKey && stampedIso < todayIso;
      });

      if (staleRows.length === 0) {
        try { sessionStorage.setItem(guardKey, todayIso); } catch (e) { /* private mode */ }
        return;
      }

      try {
        const cartResponse = await fetch(`${theme.routes.cart}.js?t=${Date.now()}`, { cache: 'no-store' });
        const cart = await cartResponse.json();
        if (!cartResponse.ok || !Array.isArray(cart.items)) return;

        const sections = [...new Set(this.getSectionsToRender().map((section) => section.section))];
        let lastState = null;
        let processed = 0;

        for (let i = 0; i < staleRows.length; i += 1) {
          const row = staleRows[i];
          const item = cart.items.find((line) => line.key === row.dataset.lineKey);
          if (!item) {
            processed += 1;
            continue; // eslint-disable-line no-continue
          }

          // /cart/change.js REPLACES the property set, so carry every existing
          // property across and overwrite only the ETA stamps.
          const properties = Object.assign({}, item.properties || {}, {
            Arrives: row.dataset.etaFreshLabel,
            _eta_days: row.dataset.etaFreshDays,
            _eta_extra: row.dataset.etaFreshExtra,
            _eta_source: row.dataset.etaFreshSource,
            _eta_stamped_on: todayIso
          });

          const body = { id: item.key, quantity: item.quantity, properties };
          if (i === staleRows.length - 1) {
            body.sections = sections;
            body.sections_url = window.location.pathname;
          }

          const response = await fetch(theme.routes.cartChange, { // eslint-disable-line no-await-in-loop
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
          });
          const state = await response.json(); // eslint-disable-line no-await-in-loop
          if (response.ok) {
            lastState = state;
            processed += 1;
          }
        }

        if (processed !== staleRows.length) return;

        try { sessionStorage.setItem(guardKey, todayIso); } catch (e) { /* private mode */ }

        if (lastState && lastState.sections) {
          this.getSectionsToRender().forEach((section) => {
            const sectionEl = document.getElementById(section.id);
            if (!sectionEl || !lastState.sections[section.section]) return;
            const el = sectionEl.querySelector(section.selector) || sectionEl;
            el.innerHTML = CartItems.getElementHTML(lastState.sections[section.section], section.selector);
          });
          if (typeof window.initCartDiscountPanels === 'function') window.initCartDiscountPanels();
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'rs_eta_restamp', eta_lines: staleRows.length });
      } catch (error) {
        console.warn('ETA restamp skipped:', error); // eslint-disable-line no-console
      }
    }

    /**
     * Today's date as YYYY-MM-DD in the browser's timezone (fallback when the
     * shop-timezone value from window.RS_ETA is unavailable).
     * @returns {string}
     */
    static localIsoDate() {
      const d = new Date();
      const pad = (n) => (n < 10 ? `0${n}` : `${n}`);
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    }

    /**
     * Handles 'change' events on the cart items element.
     * @param {object} evt - Event object.
     */
    handleChange(evt) {
      this.updateQuantity(evt.target.dataset.index, evt.target.value, document.activeElement.name);
    }

    /**
     * Updates the quantity of a line item.
     * @param {number} line - Line item index.
     * @param {number} quantity - Quantity to set.
     * @param {string} name - Active element name.
     */
    async updateQuantity(line, quantity, name) {
      const cartDrawerContent = this.cartDrawer ? this.cartDrawer.querySelector('.drawer__content') : null;
      const cartDrawerContentScroll = cartDrawerContent ? cartDrawerContent.scrollTop : 0;
      const cartDrawerScroll = this.cartDrawer ? this.cartDrawer.scrollTop : 0;

      this.enableLoading(line);

      // clear all errors except this line's (which will be refreshed after this update)
      const lineErrorsId = `line-item-error-${line}`;
      const lineErrors = document.getElementById(lineErrorsId);
      document.querySelectorAll(`.cart-errors, .cart-item__error:not([id="${lineErrorsId}"])`).forEach((el) => {
        el.innerHTML = '';
        el.hidden = true;
      });

      const sections = this.getSectionsToRender().map((section) => section.section);
      this.fetchRequestOpts.body = JSON.stringify({
        line,
        quantity,
        sections: [...new Set(sections)],
        sections_url: window.location.pathname
      });

      try {
        const lineItem = document.getElementById(`cart-item-${line}`);
        const variantId = Number(lineItem.dataset.variantId);
        const oldTotalQuantity = this.currentTotalItemCount;
        const response = await fetch(theme.routes.cartChange, this.fetchRequestOpts);
        const data = await response.json();

        if (!response.ok) throw new Error(data.errors || response.status);

        const newTotalQuantity = data.item_count;

        if (this.cartDrawer) {
          
          cartDrawerContent.classList.toggle('drawer__content--flex', newTotalQuantity === 0);
      

          if (newTotalQuantity === 0) {
            const recommendations = this.cartDrawer.querySelector('product-recommendations');
            if (recommendations) recommendations.remove();
          }
        } else if (newTotalQuantity === 0) {
         
          // We're on the Cart page
          const cartTitle = this.closest('.cc-main-cart').querySelector('.js-cart-title');
          if (cartTitle) cartTitle.style.textAlign = 'center';

          const cartSummaryCss = document.getElementById('cart-summary-css');
          if (cartSummaryCss) cartSummaryCss.remove();

          const cartContent = document.getElementById('cart-summary-and-blocks');
          if (cartContent) cartContent.hidden = true;
        }

        this.getSectionsToRender().forEach((section) => {
          const sectionEl = document.getElementById(section.id);
          if (!sectionEl) return;

          const { selector } = section;
          const el = sectionEl.querySelector(selector) || sectionEl;
          el.innerHTML = CartItems.getElementHTML(data.sections[section.section], selector);
        });

        if (this.cartDrawer && newTotalQuantity === 0) {
          cartDrawerContent.classList.add('grow', 'flex', 'items-center');

          if (this.cartDrawer.querySelector('promoted-products')) {
            this.cartDrawer
              .querySelector('.drawer__content')
              .classList.toggle('drawer__empty-with-promotions', newTotalQuantity === 0);
          }
        }

        this.updateRecommendations(data.item_count > 0 ? data.items[0].product_id : null);
        this.updateLiveRegions(Number(quantity) === 0);
        this.setFocus(line, newTotalQuantity, name);
        this.dataset.empty = newTotalQuantity === 0;
        this.currentTotalItemCount = newTotalQuantity;

        // Fire the on:line-item:change event if the line item quantity has changed
        if (oldTotalQuantity !== newTotalQuantity) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: data,
              variantId,
              oldQuantity: this.currentQuantities[variantId],
              newQuantity: Number(quantity)
            }
          }));
        }

        this.currentQuantities[variantId] = Number(quantity);

        lineErrors.innerHTML = '';
        lineErrors.hidden = true;

        if (typeof window.initCartDiscountPanels === 'function') window.initCartDiscountPanels();
      } catch (error) {
        if (/^[0-9]+$/.test(error.message)) {
          lineErrors.textContent = theme.strings.cartError;
        } else {
          lineErrors.textContent = error.message;
        }
        lineErrors.hidden = false;
        console.log(error); // eslint-disable-line

        this.querySelectorAll('.cart-item__loader').forEach((loader) => {
          loader.hidden = true;
          
        });

        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: error.message
          }
        }));

        const input = document.getElementById(`quantity-${line}`);
        input.value = input.dataset.initialValue;
        input.closest('quantity-input').currentQty = input.dataset.initialValue;
      } finally {
        this.classList.remove('pointer-events-none');

        // Attempt to maintain the same scroll position in the cart drawer
        if (cartDrawerContent) {
          requestAnimationFrame(() => { cartDrawerContent.scrollTop = cartDrawerContentScroll; });
          setTimeout(() => { cartDrawerContent.scrollTop = cartDrawerContentScroll; }, 0);
          requestAnimationFrame(() => { this.cartDrawer.scrollTop = cartDrawerScroll; });
          setTimeout(() => { this.cartDrawer.scrollTop = cartDrawerScroll; }, 0);
        }
      }
    }

    /**
     * Refreshes the cart by rerendering its sections and updating its product recommendations.
     */
    async refresh() {
      const errors = document.getElementById('cart-errors');
      try {
        const sections = this.getSectionsToRender().map((section) => section.section);
        const response = await fetch(`?sections=${[...new Set(sections)]}`);

        // The status is 400, refresh the whole cart and stop
        if (response.status === 400 && this.cartDrawer) {
          this.cartDrawer.refresh(true);
          return;
        }

        const data = await response.json();

        if (!response.ok) throw new Error(response.status);

        this.getSectionsToRender().forEach((section) => {
          const sectionEl = document.getElementById(section.id);
          if (!sectionEl) return;

          const el = sectionEl.querySelector(section.selector) || sectionEl;
          el.innerHTML = CartItems.getElementHTML(data[section.section], section.selector);
        });

        const firstCartItem = this.querySelector('.cart-item:first-child');
        this.updateRecommendations(firstCartItem ? firstCartItem.dataset.productId : null);
        

        errors.innerHTML = '';
        errors.hidden = true;

        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
      } catch (error) {
        errors.textContent = theme.strings.cartError;
        errors.hidden = false;
        console.log(error); // eslint-disable-line

        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: error.message
          }
        }));
      }
    }

    /**
     * Returns an array of objects containing required section details.
     * @returns {Array}
     */
    getSectionsToRender() {
      let sections = [
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        },
        {
          id: 'free-shipping-notice',
          section: 'free-shipping-notice',
          selector: '.free-shipping-notice'
        }
      ];

      if (this.cartDrawer) {
        const cartDrawerId = this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '');
        sections = [
          ...sections,
          {
            id: 'cart-items',
            section: cartDrawerId,
            selector: 'cart-items'
          },
          {
            id: 'cart-promo-reminder',
            section: cartDrawerId,
            selector: '#cart-promo-reminder'
          },
          {
            id: 'cart-promoted-products',
            section: cartDrawerId,
            selector: '#cart-promoted-products'
          },
          {
            id: 'cart-drawer',
            section: cartDrawerId,
            selector: '.cart-drawer__summary'
          },
          {
            id: 'cart-drawer-membership-mount',
            section: cartDrawerId,
            selector: '#cart-drawer-membership-mount'
          },
          {
            id: 'cart-drawer-media-promotion',
            section: cartDrawerId,
            selector: '#cart-drawer-media-promotion'
          }
        ];
      } else {
        sections = [
          ...sections,
          {
            id: 'cart-items',
            section: this.dataset.section,
            selector: 'cart-items'
          },
          {
            id: 'cart-page-upsells',
            section: this.dataset.section,
            selector: '#cart-page-upsells'
          },
          {
            id: 'cart-summary',
            section: document.getElementById('cart-summary').dataset.section,
            selector: '.cart__summary'
          }
        ];

        const cartPageRecommendations = document.getElementById('cart-page-recommendations');
        if (cartPageRecommendations) {
          sections.push({
            id: 'cart-page-recommendations',
            section: cartPageRecommendations.dataset.section,
            selector: '#cart-page-recommendations'
          });
        }
      }

      return sections;
    }

    /**
     * Gets the innerHTML of an element.
     * @param {string} html - Section HTML.
     * @param {string} selector - CSS selector for the element to get the innerHTML of.
     * @returns {string}
     */
    static getElementHTML(html, selector) {
      const tmpl = document.createElement('template');
      tmpl.innerHTML = html;

      const el = tmpl.content.querySelector(selector);
      return el ? el.innerHTML : '';
    }

    /**
     * Shows a loading icon over a line item.
     * @param {string} line - Line item index.
     */
    enableLoading(line) {
      this.classList.add('pointer-events-none');

      const loader = this.querySelector(`#cart-item-${line} .cart-item__loader`);
      if (loader) loader.hidden = false;

      document.activeElement.blur();
      if (this.itemStatus) this.itemStatus.setAttribute('aria-hidden', 'false');
    }

    /**
     * Updates the cart recommendations.
     * @param {string} productId - The product id for which to find recommendations.
     */
    updateRecommendations(productId) {
      this.recommendations = this.recommendations || document.getElementById('cart-recommendations');
      if (!this.recommendations) return;

      if (productId) {
        this.recommendations.dataset.productId = productId;
        this.recommendations.init();
      } else {
        this.recommendations.innerHTML = '';
      }
    }

    /**
     * Updates the live regions.
     * @param {boolean} [removed=false] - Whether the change removed a line item.
     */
    updateLiveRegions(removed = false) {
      this.itemStatus.setAttribute('aria-hidden', 'true');

      const cartStatus = document.getElementById('cart-live-region-text');
      if (!cartStatus) return;

      // Prepend an explicit outcome message before the (re-rendered) subtotal
      // so screen readers announce what happened, not just the new total.
      const strings = (window.theme && theme.strings) || {};
      const msg = removed
        ? (strings.cartItemRemoved || 'Item removed')
        : (strings.cartUpdated || 'Cart updated');
      cartStatus.textContent = `${msg}. ${cartStatus.textContent.trim()}`;
      cartStatus.setAttribute('aria-hidden', 'false');

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', 'true');
      }, 1000);
    }

    /**
     * Traps focus in the relevant container or focuses the active element.
     * @param {number} line - Line item index.
     * @param {number} itemCount - Item count.
     * @param {string} name - Active element name.
     */
    setFocus(line, itemCount, name) {
      const lineItem = document.getElementById(`cart-item-${line}`);
      let activeEl;

      if (lineItem) {
        activeEl = lineItem.querySelector(`[name="${name}"]`);
      }

      if (this.cartDrawer) {
setTimeout(() => {
  this.checkAndRemoveSpecificProduct();
}, 2000);
       
        if (lineItem && activeEl) {
          trapFocus(this.cartDrawer, activeEl);
        }

        else if (itemCount === 0) {
          trapFocus(
            this.cartDrawer.querySelector('.js-cart-empty'),
            this.cartDrawer.querySelector('a')
          );
        } else if (this.cartDrawer.querySelector('.cart-item')) {
          trapFocus(this.cartDrawer, document.querySelector('.js-item-name'));
        }
      } else if (lineItem && activeEl) {
        activeEl.focus();
      }
    }
  }

  customElements.define('cart-items', CartItems);
}

(function initCartSaveForLater() {
  if (document.documentElement.dataset.cartSaveForLaterBound === 'true') return;
  document.documentElement.dataset.cartSaveForLaterBound = 'true';

  function getElementHTML(html, selector) {
    const tmpl = document.createElement('template');
    tmpl.innerHTML = html;
    const el = tmpl.content.querySelector(selector);
    return el ? el.innerHTML : '';
  }

  const DEFAULT_WISHLIST_BOARD_TITLE = 'My Saves';
  const BOARDS_SAVED_KEY = 'rs_boards_saved';

  function waitForRSBoards(timeout = 8000) {
    return new Promise((resolve) => {
      if (window.RSBoards && typeof window.RSBoards.save === 'function' && typeof window.RSBoards.list === 'function') {
        resolve(true);
        return;
      }

      const start = Date.now();
      let onReady;

      const finish = (ok) => {
        if (onReady) document.removeEventListener('rs-boards:ready', onReady);
        resolve(ok);
      };

      onReady = () => finish(!!(window.RSBoards && typeof window.RSBoards.save === 'function' && typeof window.RSBoards.list === 'function'));
      document.addEventListener('rs-boards:ready', onReady);

      (function check() {
        if (window.RSBoards && typeof window.RSBoards.save === 'function' && typeof window.RSBoards.list === 'function') {
          finish(true);
          return;
        }
        if (Date.now() - start > timeout) {
          finish(false);
          return;
        }
        setTimeout(check, 150);
      })();
    });
  }

  function findDefaultWishlistBoard(boards) {
    return (boards || []).find((board) => board.title === DEFAULT_WISHLIST_BOARD_TITLE) || null;
  }

  async function fetchBoardsForSave() {
    const cached = typeof window.RSBoards.cachedBoards === 'function'
      ? window.RSBoards.cachedBoards()
      : null;
    if (cached && cached.length) return cached;

    const swr = typeof window.RSBoards.listSWR === 'function'
      ? window.RSBoards.listSWR()
      : null;
    if (swr?.cached?.length) return swr.cached;
    if (swr?.promise) return swr.promise;

    return window.RSBoards.list();
  }

  function buildDefaultWishlistPayload(productPayload, boardId) {
    const payload = {};
    Object.keys(productPayload).forEach((key) => {
      if (productPayload[key] != null) payload[key] = productPayload[key];
    });
    if (boardId) payload.boardId = boardId;
    else payload.newTitle = DEFAULT_WISHLIST_BOARD_TITLE;
    return payload;
  }

  async function saveProductToDefaultWishlist(productPayload) {
    const boards = await fetchBoardsForSave();
    const defaultBoard = findDefaultWishlistBoard(boards);

    try {
      return await window.RSBoards.save(buildDefaultWishlistPayload(productPayload, defaultBoard?.id || null));
    } catch (error) {
      if (error?.message !== 'Already exists') throw error;

      const freshBoards = await window.RSBoards.list();
      const retryBoard = findDefaultWishlistBoard(freshBoards);
      if (!retryBoard?.id) throw error;

      return window.RSBoards.save(buildDefaultWishlistPayload(productPayload, retryBoard.id));
    }
  }

  async function refreshWishlistHeaderCount() {
    if (!window.RSBoards || typeof window.RSBoards.list !== 'function') return;

    try {
      if (typeof window.RSBoards.bustBoards === 'function') window.RSBoards.bustBoards();
      const boards = await window.RSBoards.list();
      const total = (boards || []).reduce((count, board) => count + (board.itemCount || 0), 0);
      document.querySelectorAll('.wishlist-h-count, .wishlist-total-count').forEach((el) => {
        el.textContent = String(total);
        el.setAttribute('data-total', String(total));
      });
    } catch (error) {
      // ignore
    }
  }

  function markBoardsProductSaved(productId) {
    if (!productId) return;

    try {
      const saved = new Set(JSON.parse(localStorage.getItem(BOARDS_SAVED_KEY) || '[]'));
      saved.add(String(productId));
      localStorage.setItem(BOARDS_SAVED_KEY, JSON.stringify(Array.from(saved)));
    } catch (error) {
      // ignore
    }

    document.querySelectorAll(`[data-rs-board-picker][data-product-id="${productId}"] .rs-bp__heart`)
      .forEach((heart) => heart.classList.add('is-saved'));

    if (typeof window.RSBoards.bustBoards === 'function') window.RSBoards.bustBoards();
    refreshWishlistHeaderCount();
  }

  async function saveToWishlist(el) {
    const ready = await waitForRSBoards();
    if (!ready || !window.RSBoards) {
      throw new Error('Wishlist is unavailable right now.');
    }

    const productId = el.dataset.productId || el.dataset.product_id;
    const variantId = el.dataset.variantId || el.dataset.variant_id;

    await saveProductToDefaultWishlist({
      productId: String(productId),
      variantId: variantId ? String(variantId) : null,
      handle: el.dataset.handle || null,
      title: el.dataset.productTitle || null,
      imageUrl: el.dataset.image || null
    });

    markBoardsProductSaved(productId);
  }

  function pushSaveForLaterAnalytics(el) {
    const price = parseFloat(el.dataset.price, 10) || 0;
    const itemId = el.dataset.sku || String(el.dataset.variantId || el.dataset.variant_id || '');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'add_to_wishlist',
      ecommerce: {
        value: price,
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active)
          || (window.Shopify && Shopify.currency && Shopify.currency.shopCurrency)
          || 'USD',
        items: [{
          item_name: el.dataset.productTitle || '',
          item_id: itemId,
          price: String(price),
          item_brand: el.dataset.productBrand || '',
          item_category: el.dataset.productCategory || '',
          quantity: 1
        }]
      }
    });
  }

  function setSaveForLaterLoading(el, isLoading) {
    el.classList.toggle('is-loading', isLoading);
    el.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    if (isLoading) {
      el.setAttribute('aria-disabled', 'true');
    } else {
      el.removeAttribute('aria-disabled');
    }
  }

  const WISHLIST_TOAST_DURATION_MS = 5000;
  const WISHLIST_TOAST_TRANSITION_MS = 300;
  let wishlistToastHideTimer;

  function showCartDrawerWishlistToast() {
    const toast = document.getElementById('cart-drawer-wishlist-toast');
    if (!toast) return;

    clearTimeout(wishlistToastHideTimer);

    if (toast.classList.contains('is-visible')) {
      wishlistToastHideTimer = setTimeout(() => {
        hideCartDrawerWishlistToast();
      }, WISHLIST_TOAST_DURATION_MS);
      return;
    }

    toast.classList.remove('is-visible');
    toast.setAttribute('aria-hidden', 'true');
    void toast.offsetHeight;

    requestAnimationFrame(() => {
      toast.classList.add('is-visible');
      toast.setAttribute('aria-hidden', 'false');
    });

    wishlistToastHideTimer = setTimeout(() => {
      hideCartDrawerWishlistToast();
    }, WISHLIST_TOAST_DURATION_MS);
  }

  function hideCartDrawerWishlistToast() {
    const toast = document.getElementById('cart-drawer-wishlist-toast');
    if (!toast || !toast.classList.contains('is-visible')) return;

    clearTimeout(wishlistToastHideTimer);
    toast.classList.remove('is-visible');

    setTimeout(() => {
      if (!toast.classList.contains('is-visible')) {
        toast.setAttribute('aria-hidden', 'true');
      }
    }, WISHLIST_TOAST_TRANSITION_MS);
  }

  const UPSELL_DAMAGE_HANDLE = '100-damage-protection';
  const UPSELL_DAMAGE_VARIANT_ID = 46692864065836;

  /** Either membership product may be the cart line — carts predating the 2026 product hold the legacy one. */
  function getMembershipProductIds() {
    const body = document.body;
    if (!body) return [];
    const raw = body.dataset.membershipProductIds || body.dataset.membershipProductId || '';
    return raw
      .split(',')
      .map((value) => Number(value.trim()))
      .filter((value) => value && !Number.isNaN(value));
  }

  function isUpsellCartLine(item) {
    if (!item) return false;
    if (getMembershipProductIds().includes(item.product_id)) return true;
    const url = item.url || '';
    if (url.includes(UPSELL_DAMAGE_HANDLE)) return true;
    return item.id === UPSELL_DAMAGE_VARIANT_ID || item.variant_id === UPSELL_DAMAGE_VARIANT_ID;
  }

  function cartHasProductItems(cart) {
    return Array.isArray(cart.items) && cart.items.some((item) => !isUpsellCartLine(item));
  }

  async function clearUpsellItems(cart, sections) {
    const updates = {};
    cart.items.forEach((item) => {
      if (isUpsellCartLine(item)) updates[item.key] = 0;
    });

    if (!Object.keys(updates).length) return cart;

    const body = { updates };
    if (sections && sections.length) {
      body.sections = sections;
      body.sections_url = window.location.pathname;
    }

    const response = await fetch(theme.routes.cartUpdate, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.errors || data.message || 'Could not update cart.');
    return data;
  }

  function applyEmptyCartDrawerState(cartDrawer, isEmpty) {
    if (!cartDrawer) return;
    const cartDrawerContent = cartDrawer.querySelector('.drawer__content');
    if (cartDrawerContent) {
      cartDrawerContent.classList.toggle('drawer__content--flex', isEmpty);
      if (isEmpty) {
        cartDrawerContent.classList.add('grow', 'flex', 'items-center');
      } else {
        cartDrawerContent.classList.remove('grow', 'flex', 'items-center');
      }
    }
    if (isEmpty) {
      cartDrawer.querySelector('product-recommendations')?.remove();
    }
  }

  function applyEmptyCartPageState(cartItems) {
    if (!cartItems || cartItems.cartDrawer) return;
    const cartTitle = cartItems.closest('.cc-main-cart')?.querySelector('.js-cart-title');
    if (cartTitle) cartTitle.style.textAlign = 'center';
    document.getElementById('cart-summary-css')?.remove();
    const cartContent = document.getElementById('cart-summary-and-blocks');
    if (cartContent) cartContent.hidden = true;
  }

  function renderCartSections(cartItems, data) {
    cartItems.getSectionsToRender().forEach((section) => {
      const sectionEl = document.getElementById(section.id);
      if (!sectionEl) return;
      const target = sectionEl.querySelector(section.selector) || sectionEl;
      target.innerHTML = getElementHTML(data.sections[section.section], section.selector);
    });
  }

  async function removeCartLineAndRefresh(line) {
    const cartItems = document.querySelector('cart-items');
    const cartDrawer = document.getElementById('cart-drawer');
    const sections = cartItems && typeof cartItems.getSectionsToRender === 'function'
      ? [...new Set(cartItems.getSectionsToRender().map((section) => section.section))]
      : null;

    const changeBody = {
      line: parseInt(line, 10),
      quantity: 0
    };

    if (sections) {
      changeBody.sections = sections;
      changeBody.sections_url = window.location.pathname;
    }

    let response = await fetch(theme.routes.cartChange, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(changeBody)
    });
    let data = await response.json();
    if (!response.ok) throw new Error(data.errors || data.message || 'Could not update cart.');

    if (!cartHasProductItems(data)) {
      data = await clearUpsellItems(data, sections);
    }

    const isEmpty = data.item_count === 0;

    if (isEmpty && cartDrawer && typeof cartDrawer.refresh === 'function') {
      await cartDrawer.refresh(true);
    } else if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
      renderCartSections(cartItems, data);
      applyEmptyCartDrawerState(cartDrawer, isEmpty);
    }

    if (cartItems) {
      cartItems.dataset.empty = isEmpty ? 'true' : 'false';
      cartItems.currentTotalItemCount = data.item_count;
    }

    if (isEmpty) {
      applyEmptyCartPageState(cartItems);
    }

    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
    if (typeof window.initCartDiscountPanels === 'function') window.initCartDiscountPanels();
    if (typeof window.initCartDrawerMembership === 'function') window.initCartDrawerMembership();
    if (typeof window.initCartDamageProtection === 'function') window.initCartDamageProtection();

    return data;
  }

  async function handleSaveForLater(el) {
    if (el.classList.contains('is-loading')) return;

    const productId = el.dataset.productId || el.dataset.product_id;
    const variantId = el.dataset.variantId || el.dataset.variant_id;
    const line = el.dataset.line;
    const price = el.dataset.price;

    if (!productId || !variantId || !line) return;

    const inMiniCart = Boolean(el.closest('cart-drawer, #cart-drawer'));
    if (inMiniCart) showCartDrawerWishlistToast();

    setSaveForLaterLoading(el, true);

    try {
      await saveToWishlist(el);
      pushSaveForLaterAnalytics(el);
      await removeCartLineAndRefresh(line);
    } catch (error) {
      console.error('Save for later error:', error);
      if (inMiniCart) hideCartDrawerWishlistToast();
      setSaveForLaterLoading(el, false);
    }
  }

  document.addEventListener('click', (event) => {
    const el = event.target.closest('.js-cart-save-for-later');
    if (!el) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    handleSaveForLater(el);
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const el = event.target.closest('.js-cart-save-for-later');
    if (!el) return;
    event.preventDefault();
    event.stopPropagation();
    handleSaveForLater(el);
  });
})();